import { useState, ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// okta
import { useOktaAuth } from '@okta/okta-react';
import { setSession } from 'utils/jwt';
// components
import LoadingScreen from '../xx_minimalUi_old/loading-screen';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      if (authState && !authState.isAuthenticated) {
        oktaAuth.signInWithRedirect({ originalUri: '/' });
      }
      setSession(null);
    } else if (authState.idToken != null) {
      localStorage.setItem("username", authState.idToken.claims.name ?? "Inconu");
      localStorage.setItem("useremail", authState.idToken.claims.email ?? "Inconu");
      setSession(authState.idToken?.idToken);
    }
  }, [authState, oktaAuth]); // Update if authState changes

  if (!authState?.isAuthenticated) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
